import {setAuxMinimized} from "../helpers/commit_helpers";

export default function auxHeaderToggleSelected(sm, auxHeaderToggle) {
    if (sm.state['auxMinimized']) {
        setAuxMinimized(sm, false);
        auxHeaderToggle.auxHeader.onlineAppAux.scrollTo();
    } else {
        auxHeaderToggle.onlineApp.root.scrollTo(); // Causes the aux to be minimized by triggering the auxScrolledOff action.
    }
}